import { useSelectTheme } from "../../../store";
import { defaultSvgProps, SvgProps } from "../type/props";

export const PinIcon = (props?: SvgProps & { outlineFill?: string }) => {
  const { color } = useSelectTheme();
  const { width, height, style, fill, outlineFill } = defaultSvgProps(props, {
    width: 22,
    height: 48,
    fill: color.task.yellow,
    outlineFill: color.task.orange,
    style: {
      flexShrink: 0,
    },
  });
  return (
    <svg
      width={width}
      height={height}
      style={style}
      viewBox="0 0 22 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="21" height="21" rx="10.5" fill="none" />
      <rect x="0.5" y="0.5" width="21" height="21" rx="10.5" stroke={outlineFill} />
      <circle cx="11" cy="11" r="7" fill={fill} />
      <path
        d="M11 47.7735L16.7735 42L11 36.2265L5.2265 42L11 47.7735ZM10 22L10 42L12 42L12 22L10 22Z"
        fill={outlineFill}
      />
    </svg>
  );
};
